import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-user-icon',
  templateUrl: 'user-icon.component.html'
})
export class UserIconComponent {
  constructor() {}
}
